import { render, staticRenderFns } from "./reservationList.vue?vue&type=template&id=71a969a8&"
import script from "./reservationList.vue?vue&type=script&lang=ts&"
export * from "./reservationList.vue?vue&type=script&lang=ts&"
import style0 from "./reservationList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports